export enum WccIntegrationStatusType {
  WaitingAssignment = 'WAITING_ASSIGNMENT',
  Integrated = 'INTEGRATED',
  IntegrationFailed = 'INTEGRATION_FAILED',
  IntegrationInProgress = 'INTEGRATION_IN_PROGRESS',
  IntegrationCanceled = 'INTEGRATION_CANCELED',
  CancelationFAILED = 'CANCELATION_FAILED'
}
